import { AnimatePresence, motion } from 'framer-motion';
import { useQuizStore } from '@/stores/quiz-store';
import { QuizProgress } from './quiz-progress';

interface QuizContainerProps {
  variant: string;
}

/**
 * Main quiz wrapper. Renders steps based on variant.
 *
 * To add a new quiz variant:
 * 1. Create a config in @/config/quiz-variants.ts
 * 2. Define steps as React components
 * 3. Register the variant key
 */
export function QuizContainer({ variant }: QuizContainerProps) {
  const { currentStep } = useQuizStore();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <div className="w-full max-w-xl">
        <QuizProgress />

        <AnimatePresence mode="wait">
          <motion.div
            key={currentStep}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.2 }}
          >
            {/* TODO: Render quiz step based on variant + currentStep */}
            <div className="rounded-lg border bg-card p-6 text-card-foreground shadow-sm">
              <h2 className="text-xl font-semibold mb-4">
                Quiz — variant: {variant}, step: {currentStep + 1}
              </h2>
              <p className="text-muted-foreground">
                Replace this with your quiz step component.
              </p>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
